{
  "forms": {
    "save": "Save",
    "cancel": "Cancel",
    "add": "Add",
    "update": "Update",
    "edit": "Edit",
    "delete": "Delete",
    "confirm": "Confirm",
    "submit": "Submit",
    "create": "Create",
    "search": "Search",
    "search_placeholder": "Search...",
    "select": "Select",
    "clear": "Clear",
    "reset": "Reset",
    "apply": "Apply"
  },
  "nav": {
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "close": "Close",
    "open": "Open",
    "refresh": "Refresh"
  },
  "status": {
    "loading": "Loading...",
    "saving": "Saving...",
    "deleting": "Deleting...",
    "updating": "Updating...",
    "processing": "Processing...",
    "success": "Success",
    "error": "Error",
    "warning": "Warning",
    "info": "Info",
    "not_found": "Not Found",
    "items_selected": "Items Selected"
  },
  "actions": {
    "view": "View",
    "download": "Download",
    "upload": "Upload",
    "import": "Import",
    "export": "Export",
    "remove": "Remove",
    "share": "Share",
    "archive": "Archive",
    "filters": {
      "title": "Filters",
      "clear_filter": "Clear filter",
      "more_filters": "More filters",
      "add_filter": "Add Filter",
      "is": "is",
      "one_of": "one of",
      "and": "and"
    },
    "restore": "Restore",
    "duplicate": "Duplicate",
    "rename": "Rename"
  },
  "confirmation": {
    "are_you_sure": "Are you sure?",
    "cannot_be_undone": "This action cannot be undone.",
    "confirm_delete": "Are you sure you want to delete this?",
    "confirm_archive": "Are you sure you want to archive this?",
    "click_confirm": "Click confirm to continue"
  },
  "errors": {
    "context_provider_required": "useZIndex must be used within a ZIndexProvider"
  }
}
